import { createRoute, lazyRouteComponent, Outlet } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';
import RequireWarehouse from 'root/RequireWarehouse';

import TaskManagementEnabledRoute from './TaskManagementEnabledRoute';

const TasksRequireWarehouse = () => {
  return (
    <RequireWarehouse
      routeWithWarehouseId="/tasks/warehouse/$warehouseId"
      routeWithoutWarehouseId="/tasks"
    >
      <Outlet />
    </RequireWarehouse>
  );
};

const tasksRequireWarehouseRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: '/tasks',
  component: TasksRequireWarehouse,
  validateSearch: z.object({
    filter: z.enum(['NEW', 'IN_PROGRESS', 'OTHERS']).catch('NEW'),
  }).parse,
});

const taskManagementEnabledRoute = createRoute({
  getParentRoute: () => tasksRequireWarehouseRoute,
  id: 'tasks-enabled',
  component: TaskManagementEnabledRoute,
});

const tasksWarehouseWrapperRoute = createRoute({
  getParentRoute: () => taskManagementEnabledRoute,
  path: 'warehouse/$warehouseId',
  parseParams: (params) => ({ warehouseId: z.string().uuid().parse(params.warehouseId) }),
});

export const tasksRoute = createRoute({
  getParentRoute: () => tasksWarehouseWrapperRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./TaskManagementView')),
});

export const taskDetailsRoute = createRoute({
  getParentRoute: () => tasksWarehouseWrapperRoute,
  path: '/$taskId',
  component: lazyRouteComponent(() => import('./TaskDetailsView')),
  parseParams: (params) => ({ taskId: z.string().parse(params.taskId) }),
  validateSearch: z.object({
    searchQuery: z.coerce.string().optional(),
    viewSubtaskDetailsForSubtaskId: z.string().optional(),
  }).parse,
});

export const tasksRouteTree = tasksRequireWarehouseRoute.addChildren({
  taskManagementEnabledRoute: taskManagementEnabledRoute.addChildren({
    tasksWarehouseWrapperRoute: tasksWarehouseWrapperRoute.addChildren({
      taskDetailsRoute,
      tasksRoute,
    }),
  }),
});
